export default __webpack_public_path__ + "static/media/gmx_logo.851636bc.svg";